import { render, staticRenderFns } from "./9introduce.vue?vue&type=template&id=470e3c80&scoped=true&"
import script from "./9introduce.vue?vue&type=script&lang=js&"
export * from "./9introduce.vue?vue&type=script&lang=js&"
import style0 from "./9introduce.vue?vue&type=style&index=0&id=470e3c80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e3c80",
  null
  
)

export default component.exports